import request from "@/utils/request";

export function getAll() {
  return request({
    url: "/base/companyInfoFactory/getAll",
    method: "get",
  });
}

export function getPage(condition, pagination) {
  return request({
    url: "/base/companyInfoFactory/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

export function saveOrUpdate(data) {
  return request({
    url: "/base/companyInfoFactory/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/base/companyInfoFactory/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/base/companyInfoFactory/deleteById",
    method: "post",
    data: { id: id },
  });
}

export function deleteBatchByIds(ids) {
  return request({
    url: "/base/companyInfoFactory/deleteBatchById",
    method: "post",
    data: { ids: ids },
  });
}

export function exportExcel(condition, pagination) {
  return request({
    url: "/base/companyInfoFactory/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}
